import { NavigationConfirmationDialog } from "$routes/patient/_lib/navigation-confirmation-dialog";

export const ConsultationNavigationConfirmationDialog: FC<
  Omit<
    React.ComponentProps<typeof NavigationConfirmationDialog>,
    "bodyMessageId" | "bodyDefaultMessage" | "title"
  >
> = (props) => {
  return (
    <NavigationConfirmationDialog
      {...props}
      title="You have not submitted this consultation"
      bodyMessageId="patient.consultation.leavePage"
      bodyDefaultMessage="If you leave the page now, you will discard the consultation and any data entered in it."
    />
  );
};
